<template>

<main class="py-12 space-y-12">
        <section>
            <div class="container">
                <p class="font-bold">
                    Kein Verkauf an Privat! Fragen Sie uns an, gerne teilen wir einen Händler mit.
                </p>
            </div>
        </section>

        <section>
            <div class="container grid lg:grid-cols-9 gap-12">
                <div class="order-2 lg:col-span-6 lg:order-1">
                    <ContactForm/>
                </div>
                <div class="order-1 lg:col-span-3 lg:order-2">
                    <p>
                        <strong>Sauerland Spielgeräte GmbH</strong><br>
                        Kamp 7<br>
                        33154 Salzkotten - Niederntudorf
                    </p>
                    <p>
                        Telefon: +49 (0) 2955 7606 0<br>
                        Telefax: +49 (0) 2955 7606 221<br>
                        E-Mail: <a href="mailto:info@sauerland-spielgeraete.de">info@sauerland-spielgeraete.de</a>
                    </p>
                </div>
            </div>
        </section>
    </main>
</template>

<script setup lang="ts">
import ContactForm from '~/components/ContactForm.vue';

definePageMeta({
    path: '/Service/Kontakt',
});

const header = useState<{ title: string; subTitle: string }>(
    'header',
);
header.value = {
    title: 'Eine Welt',
    subTitle: 'voller Kontakt',
};
</script>

<style scoped>

</style>
